import { css, cx, useTheme } from '@fable/theme'
import { CarouselController, CarouselControls } from 'components/carousel'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  controller: CarouselController
}

export const BookDetailValuePropsControls = ({
  controller,
  className,
  ...props
}: Props) => {
  const { colors, mediaQueries } = useTheme()

  return (
    <CarouselControls
      className={cx(
        css`
          display: none;
          ${mediaQueries.tabletL} {
            display: flex;
          }
        `,
        className
      )}
      controller={controller}
      {...props}
      controlProps={{
        outline: true,
        custom: {
          borderColor: colors.whiteSmoke,
          borderWidth: '1px',
          '&:hover': { borderColor: colors.graphite },
          '&:disabled': { borderColor: colors.almostWhite },
        },
      }}
    />
  )
}
